// extracted by mini-css-extract-plugin
export default {"wrapper":"Accordion_wrapper__yLfGq","withMarker":"Accordion_withMarker__2WJkl","heading":"Accordion_heading__WmKSK","button":"Accordion_button__8xVW2"};